export const request = {
  Email: 'e',
  Name: 'n',
  Password: 'pswd'
}

export const response = {
  _id: 'Id',
  u: 'User',
  grpid: 'Communities'
}



// WEBPACK FOOTER //
// ./src/store/consts.js